import React, { useId, useState } from "react";

export const TERMS_URL = "https://color-analysis.pro/terms";

function LegalLink({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-inherit no-underline"
    >
      {children}
    </a>
  );
}

function TrialText({ emphasize }) {
  if (emphasize) {
    return <strong>7-day trial</strong>;
  }

  return <>7-day trial</>;
}

function PriceText({ price, billingPeriod, emphasize }) {
  const text = `${price} ${billingPeriod}`;

  if (emphasize) {
    return <strong>{text}</strong>;
  }

  return <>{text}</>;
}

function DisclaimerCopy({ price, billingPeriod, emphasize = false }) {
  return (
    <>
      By continue you agree that after the{" "}
      <TrialText emphasize={emphasize} /> period ends, Color-analysis.pro will
      automatically continue your membership and charge{" "}
      <PriceText
        price={price}
        billingPeriod={billingPeriod}
        emphasize={emphasize}
      />{" "}
      until you cancel it online in the personal account or by email. Learn
      more about cancellation and refund policy in{" "}
      <LegalLink href={TERMS_URL}>Terms</LegalLink>.
    </>
  );
}

function SubscriptionDisclaimer({
  price,
  billingPeriod = "every 3 months",
  className,
  organicClassName,
  isOrganicOrSeo = false,
}) {
  const labelId = useId();
  const [isChecked, setIsChecked] = useState(true);

  if (isOrganicOrSeo) {
    return (
      <div
        className={
          organicClassName ||
          "flex items-start gap-2 text-[#111827] text-sm leading-relaxed text-left"
        }
      >
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(event) => setIsChecked(event.target.checked)}
          aria-labelledby={labelId}
          className="mt-0.5 h-4 w-4 shrink-0"
        />
        <p id={labelId} className="m-0">
          <DisclaimerCopy
            price={price}
            billingPeriod={billingPeriod}
            emphasize
          />
        </p>
      </div>
    );
  }

  return (
    <p className={className}>
      <DisclaimerCopy price={price} billingPeriod={billingPeriod} />
    </p>
  );
}

export default SubscriptionDisclaimer;
